import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
@Component({
  selector: 'hijri-gregorian-date-picker',
  templateUrl: './hijri-gregorian-date-picker.component.html',
  styleUrls: ['./hijri-gregorian-date-picker.component.scss'],
})
export class HijriGregorianDatePickerComponent implements OnInit {
  @Input() isHijri: boolean = false;
  @Input() set date(value: Date) {
    console.log("tttt" + value);
    
    if (typeof value !== 'undefined' && Date.parse(value.toString()) !== NaN) {
      value = new Date(value);
      if (!isNaN(value.getTime())) {
        this._date = `${value.getFullYear()}-${('0' + (value.getMonth() + 1)).slice(-2)}-${(
          '0' + value.getDate()
        ).slice(-2)}T12:00:00`;
      }
    }
  }
  get date(): Date {
    return moment(this._date, 'YYYY-MM-DDTHH:mm:ss').toDate();
  }
  _date: string = null;
  @Input() disable: boolean = false;
  @Output() dateChange: EventEmitter<Date> = new EventEmitter<Date>();
  constructor() {}

  ngOnInit() {}

  typeChange(event) {
    this.isHijri = event;
  }
  onDateChange(event) {
    this._date = event;
    this.dateChange.emit(this.date);
  }
}
